import type { TFunction } from 'next-i18next';
import type { FormattedScheduleType } from './useFormattedSchedule';

export const formatOpeningHours = (
  { startDay, endDay, openingTime, closingTime }: FormattedScheduleType,
  t: TFunction,
) => {
  const days = `${startDay}${endDay ? ` ${t('pdp.store.days.divider', { ns: 'lib-global-common' })} ${endDay}` : ''}`;
  const hours = `${
    openingTime ? `${openingTime} - ${closingTime}` : t('pdp.store.closed', { ns: 'lib-global-common' })
  }`;
  return `${days}: ${hours}`;
};
